import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import LopdDocuments from "@/components/LopdDocuments";
import { ShieldCheck, CheckCircle2, Clock, Loader2, ScrollText } from "lucide-react";

export default function LopdAdmin() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const { data } = await api.get("/admin/lopd");
    setData(data); setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="h-64 flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-slate-300" /></div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Cumplimiento LOPD/RGPD</h1>
        <p className="text-slate-500 text-sm mt-1">Estado del contrato de tratamiento (DPA) y consentimientos por empresa cliente.</p>
      </div>

      <Card className="p-6 border-slate-200 shadow-none">
        <div className="flex items-center gap-2 mb-4"><ScrollText className="h-5 w-5 text-sky-500" /><h3 className="font-heading font-semibold">Documentos legales globales (Fichando)</h3></div>
        <LopdDocuments documents={data.documents} />
      </Card>

      <Card className="border-slate-200 shadow-none overflow-hidden">
        <div className="p-5 border-b border-slate-100 flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-sky-500" /><h3 className="font-heading font-semibold">Estado por empresa</h3></div>
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent">
            <TableHead>Empresa</TableHead><TableHead>Contrato DPA</TableHead><TableHead>Aceptado por</TableHead><TableHead>Consentimientos</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {data.companies.map((c) => (
              <TableRow key={c.id} data-testid={`lopd-company-${c.id}`}>
                <TableCell className="font-medium text-slate-800">{c.name}</TableCell>
                <TableCell>
                  {c.dpa_accepted
                    ? <Badge className="bg-emerald-100 text-emerald-700 border-0"><CheckCircle2 className="h-3 w-3 mr-1" /> Aceptado {c.dpa_accepted_at ? `· ${new Date(c.dpa_accepted_at).toLocaleDateString("es-ES")}` : ""}</Badge>
                    : <Badge className="bg-amber-100 text-amber-700 border-0"><Clock className="h-3 w-3 mr-1" /> Pendiente</Badge>}
                </TableCell>
                <TableCell className="text-slate-600">{c.dpa_accepted_by || "—"}</TableCell>
                <TableCell className="text-slate-600">{c.consented}/{c.total_employees} empleados</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
